import React from 'react';
import clubhouse from '../Assets/CLUB HOUSE ELVATION -  (1).jpg';
import clubhouse2 from '../Assets/CLUB HOUSE ELVATION -  (2).jpg';
import clubhouse3 from '../Assets/CLUB HOUSE ELVATION -  (3).jpg';
import landscape15 from "../Assets/LANDSCAPE VIEW - (15).jpg";
import landscape16 from "../Assets/LANDSCAPE VIEW - (16).jpg";
import landscape17 from "../Assets/LANDSCAPE VIEW - (17).jpg";
import aerialview4 from '../Assets/AERIAL VIEW -  (6).jpg';

const RoyalOakEstates = () => {
  return (
    <div className="Royal Oak Estates">
      {/* Premium Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#E8E2D5]">
        <div className="container mx-auto px-4 lg:px-8 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center max-w-7xl mx-auto mb-20">
            {/* Left - Main Image */}
            <div className="relative aspect-[4/5] rounded-none overflow-hidden shadow-2xl">
              <img 
                src={clubhouse}
                alt="Royal Oak Estates - Gated Community"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Right - Secondary Image */}
            <div className="relative aspect-[16/10] rounded-none overflow-hidden shadow-2xl">
              <img 
                src={clubhouse2}
                alt="Royal Oak Estates - Modern Living"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Hero Content */}
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-block mb-6">
                <div className="w-20 h-[2px] bg-luxury-accent mx-auto"></div>
              </div>
              <h1 className="font-serif text-6xl lg:text-8xl font-bold text-luxury-dark mb-6 tracking-tight">
                Royal Oak Estates
              </h1>
              <p className="text-2xl lg:text-3xl text-luxury-primary/90 mb-6 font-light">
                15 Acres | Phase 1 Launch
              </p>
              <p className="text-xl text-luxury-primary/70 max-w-3xl mx-auto leading-relaxed">
                Zaheerabad, Bidar Road | Just 3 km from NIMZ
              </p>
            </div>

            {/* Premium Location Badge */}
            <div className="flex justify-center">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-r from-luxury-accent to-luxury-primary opacity-20 blur-xl group-hover:opacity-30 transition-opacity duration-300"></div>
                <div className="relative bg-white border border-luxury-accent/20 rounded-sm p-10 hover:shadow-2xl transition-all duration-300">
                  <div className="text-center">
                    <p className="text-luxury-primary/60 text-xs uppercase tracking-[0.3em] mb-4 font-medium">
                      Strategic Location
                    </p>
                    <h3 className="font-serif text-3xl lg:text-4xl font-bold text-luxury-dark mb-3">
                      National Investment Manufacturing Zone
                    </h3>
                    <div className="inline-flex items-center gap-2 bg-luxury-accent/10 px-6 py-2 rounded-sm">
                      <svg className="w-4 h-4 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <p className="text-luxury-accent font-semibold uppercase text-sm tracking-wider">
                        3 km from NIMZ
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg className="w-6 h-6 text-luxury-primary/60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center max-w-7xl mx-auto">
            <div>
              <span className="inline-block text-sm font-semibold uppercase tracking-[0.2em] text-luxury-accent mb-4">
                About The Project
              </span>
              <h2 className="font-serif text-4xl lg:text-6xl font-bold text-luxury-dark mb-8 leading-tight">
                A Timely Real Estate<br />Purchase Does Wonders
              </h2>
              <div className="space-y-6 text-lg text-luxury-primary leading-relaxed">
                <p>
                  In everyone's life there is at least one opportunity to build a fortune out of a small investment. For several people, Royal Oak represents that opportunity. And it just might be the one for you.
                </p>
                <p>
                  A project with excellent fundamentals. Beginning with the location, the promoters, the price, the prospects and many other pluses, some significant, some intangible.
                </p>
                <p className="font-semibold text-luxury-dark">
                  This is the project that has what it takes to redraw the wealth line in your life, your destiny. And give you a long and comfortable future if you invest now.
                </p>
              </div>
            </div>

            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src={landscape15}
                  alt="Royal Oak Estates"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-luxury-accent/10 rounded-2xl -z-10"></div>
              <div className="absolute -top-8 -left-8 w-48 h-48 bg-luxury-primary/10 rounded-full -z-10"></div>
            </div>
          </div>
        </div>
      </section>

      {/* From Little Dreams Section */}
      <section className="py-20 lg:py-32 bg-[#E8E2D5]/30">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                PHASE 1 DETAILS
              </span>
              <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6">
                From Little Dreams to Solid Assets
              </h2>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="relative order-2 lg:order-1">
                <div className="aspect-[4/5] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">
                  <img 
                    src={aerialview4}
                    alt="Plot Development"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="space-y-8 order-1 lg:order-2">
                <div>
                  <h3 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6 leading-tight">
                    Phase 1 Development
                  </h3>
                  <p className="text-xl text-luxury-primary/80 leading-relaxed mb-6">
                    Royal Oak is a 15 acre development located in Zaheerabad, on the Bidar Road, just 3 km from the National Investment Manufacturing Zone (NIMZ).
                  </p>
                  <p className="text-lg text-luxury-primary/80 leading-relaxed">
                    This phase will primarily comprise 250-300 sq.yd plots set along 33 and 40 feet wide internal roads. Plot sizes have been chosen to allow you build your home with car park and a little private garden and kitchen garden, for greenery.
                  </p>
                </div>

                {/* Key Stats */}
                <div className="grid grid-cols-2 gap-6">
                  <div className="bg-white p-6 rounded-sm shadow-lg">
                    <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">250-300</div>
                    <p className="text-luxury-primary font-semibold">Sq.Yd Plots</p>
                  </div>
                  <div className="bg-white p-6 rounded-sm shadow-lg">
                    <div className="text-4xl font-serif font-bold text-luxury-accent mb-2">33 & 40</div>
                    <p className="text-luxury-primary font-semibold">Feet Wide Roads</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Villas Section */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div className="space-y-8">
                <div>
                  <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                    RESIDENTIAL COMMUNITY
                  </span>
                  <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6 leading-tight">
                    The Villas
                  </h2>
                  <p className="text-xl text-luxury-primary/80 leading-relaxed">
                    The Royal Oak development, when fully occupied will be a community of well-designed houses set in 250 to 300 sq.yd. plots with ample open free space and lush greenery surrounding each abode.
                  </p>
                </div>

                <div className="border-l-2 border-luxury-accent/30 pl-6">
                  <p className="text-lg text-luxury-primary/80 leading-relaxed">
                    The homes, set slightly back from the 33 and 40 feet roads will enjoy complete independence and privacy. This is your plan for a lovely home in a well-conceived community with excellent amenities.
                  </p>
                </div>
              </div>

              <div className="relative">
                <div className="aspect-[3/4] rounded-none overflow-hidden shadow-2xl bg-[#E8E2D5]">
                  <img 
                    src={landscape17}
                    alt="Villa Design"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Clubhouse Section */}
      <section className="py-20 lg:py-32 bg-gradient-to-br from-luxury-accent/10 via-luxury-bg to-luxury-primary/10">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                PHASE 2 AMENITIES
              </span>
              <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6">
                The Clubhouse
              </h2>
              <p className="text-xl text-luxury-primary/80 max-w-3xl mx-auto leading-relaxed">
                An informal meeting place with a warm and welcoming environment, for like-minded neighbours to congregate
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Club House */}
              <div className="bg-white rounded-sm p-8 hover:shadow-2xl transition-all duration-300">
                <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-8 h-8 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Club House</h3>
                <p className="text-luxury-primary/80 leading-relaxed">
                  A modern facility for residents to socialize, relax, and enjoy community events together.
                </p>
              </div>

              {/* Swimming Pool */}
              <div className="bg-white rounded-sm p-8 hover:shadow-2xl transition-all duration-300">
                <div className="w-16 h-16 bg-luxury-primary/10 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-8 h-8 text-luxury-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5" />
                  </svg>
                </div>
                <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Swimming Pool</h3>
                <p className="text-luxury-primary/80 leading-relaxed">
                  A refreshing amenity for leisure and fitness, perfect for family recreation.
                </p>
              </div>

              {/* Jogging Track */}
              <div className="bg-white rounded-sm p-8 hover:shadow-2xl transition-all duration-300">
                <div className="w-16 h-16 bg-luxury-accent/10 rounded-full flex items-center justify-center mb-6">
                  <svg className="w-8 h-8 text-luxury-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h3 className="font-serif text-2xl font-bold text-luxury-dark mb-4">Jogging Track</h3>
                <p className="text-luxury-primary/80 leading-relaxed">
                  Dedicated pathways for morning runs and evening walks in a serene environment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Amenities Grid */}
      <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <span className="inline-block text-sm font-medium uppercase tracking-[0.25em] text-luxury-primary/60 mb-4">
                INVESTMENT FEATURES
              </span>
              <h2 className="font-serif text-5xl lg:text-6xl font-bold text-luxury-dark mb-6">
                Signs of a Good Investment
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[
                { icon: '✓', title: 'Clear Title', desc: 'Legally verified property documents' },
                { icon: '✓', title: 'Gated Community', desc: 'Secure and exclusive living' },
                { icon: '✓', title: '24/7 Security', desc: 'Round-the-clock protection' },
                { icon: '✓', title: 'Compound Wall', desc: 'Complete boundary security' },
                { icon: '✓', title: '33 & 40 Feet Roads', desc: 'Wide cement roads throughout' },
                { icon: '✓', title: 'Lush Greenery', desc: 'Trees lining all roads' },
                { icon: '✓', title: 'Community Parks', desc: 'Parks with seating areas' },
                { icon: '✓', title: 'Street Lights', desc: 'Well-lit roads for safety' },
                { icon: '✓', title: 'Electrical Transformer', desc: 'Dedicated power supply' },
                { icon: '✓', title: 'Water Connection', desc: 'Central bore well connection' },
                { icon: '✓', title: 'Modern Drainage', desc: 'Efficient drainage system' },
                { icon: '✓', title: 'Vastu Compliant', desc: 'East and West facing plots' },
                { icon: '✓', title: 'Immediate Registration', desc: 'Quick ownership transfer' },
              ].map((amenity, index) => (
                <div key={index} className="flex items-start gap-4 bg-luxury-bg p-6 rounded-sm hover:shadow-lg transition-all duration-300">
                  <div className="flex-shrink-0 w-8 h-8 bg-luxury-accent/10 rounded-full flex items-center justify-center">
                    <span className="text-luxury-accent font-bold">{amenity.icon}</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-luxury-dark mb-1">{amenity.title}</h4>
                    <p className="text-sm text-luxury-primary/70">{amenity.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Download Brochure Section */}
      <section className="py-20 bg-[#E8E2D5]/30">
        <div className="container mx-auto px-4 text-center">
          <div className="max-w-3xl mx-auto">
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-luxury-dark mb-6">
              Download Our Brochure
            </h2>
            <p className="text-xl text-luxury-primary/80 mb-10 leading-relaxed">
              Get detailed information about plot sizes, pricing, and payment plans
            </p>
            <button className="inline-flex items-center gap-3 px-10 py-4 bg-gradient-to-r from-luxury-accent to-luxury-primary text-white font-semibold uppercase tracking-wider rounded-sm hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download Brochure
            </button>
          </div>
        </div>
      </section>

      {/* Premium Gallery Section */}
      {/* <section className="py-20 lg:py-32 bg-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-7xl mx-auto">
      
            <div className="text-center mb-16">
              <div className="inline-block mb-6">
                <div className="w-20 h-[2px] bg-luxury-accent mx-auto"></div>
              </div>
              <h2 className="font-serif text-5xl lg:text-7xl font-bold text-luxury-dark mb-6 tracking-tight">
                Project Gallery
              </h2>
              <p className="text-xl text-luxury-primary/80 max-w-3xl mx-auto leading-relaxed">
                Explore Royal Oak Estates through our curated collection of images
              </p>
            </div>

          
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 auto-rows-[280px] gap-6">
       
              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-2 row-span-2">
                <img
                  src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&q=80"
                  alt="Royal Oak Main Entrance"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-8">
                    <h3 className="font-serif text-2xl lg:text-3xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Main Entrance & Roads
                    </h3>
                    <div className="w-16 h-[2px] bg-luxury-accent mt-4 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
                  </div>
                </div>
                <div className="absolute top-6 right-6 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="text-luxury-dark font-semibold text-sm">Featured</span>
                </div>
              </div>

          
              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-1">
                <img
                  src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=600&q=80"
                  alt="Gated Community"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Gated Community
                    </h3>
                  </div>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-1">
                <img
                  src="https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=600&q=80"
                  alt="Plot Layout"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Plot Layout
                    </h3>
                  </div>
                </div>
              </div>

          
              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-2">
                <img
                  src="https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600&q=80"
                  alt="Villa Architecture"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Villa Architecture
                    </h3>
                  </div>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-1">
                <img
                  src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=600&q=80"
                  alt="Wide Roads"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      40 Feet Roads
                    </h3>
                  </div>
                </div>
              </div>


              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-2 row-span-1">
                <img
                  src="https://plus.unsplash.com/premium_photo-1728262247661-f2f767933e29?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8cGFya3xlbnwwfHwwfHx8MA%3D%3D"
                  alt="Community Parks"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Community Parks
                    </h3>
                  </div>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-1">
                <img
                  src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=600&q=80"
                  alt="Landscaping"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Landscaping
                    </h3>
                  </div>
                </div>
              </div>

              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-1">
                <img
                  src="https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=600&q=80"
                  alt="Street View"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Street View
                    </h3>
                  </div>
                </div>
              </div>

     
              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-1 row-span-2">
                <img
                  src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=600&q=80"
                  alt="Security Features"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Security Features
                    </h3>
                  </div>
                </div>
              </div>

       
              <div className="group relative overflow-hidden rounded-sm shadow-lg hover:shadow-2xl transition-all duration-500 col-span-2 row-span-1">
                <img
                  src="https://images.unsplash.com/photo-1600585154363-67eb9e2e2099?w=800&q=80"
                  alt="Aerial View"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-luxury-dark/90 via-luxury-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="font-serif text-xl text-white transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                      Aerial View
                    </h3>
                  </div>
                </div>
              </div>
            </div>

     
            <div className="text-center mt-16">
              <a
                href="/gallery"
                className="inline-flex items-center gap-3 px-10 py-4 bg-luxury-dark text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
                View Complete Gallery
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-luxury-dark via-luxury-primary to-luxury-dark text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-luxury-accent rounded-full blur-3xl"></div>
        </div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold mb-6">
            Ready to Invest in Royal Oak?
          </h2>
          <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
            Schedule a site visit today and explore your future home at Royal Oak Estates
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-luxury-accent text-white font-semibold uppercase tracking-wider rounded-sm hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
            >
              Schedule Site Visit
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </a>
            <a
              href="tel:+919584646464"
              className="inline-flex items-center justify-center gap-3 px-10 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold uppercase tracking-wider rounded-sm border-2 border-white/30 hover:bg-white hover:text-luxury-accent transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RoyalOakEstates;